/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen..

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Phat Truong",
  title: "Hi all, I'm Phat (Peter)",
  subTitle: emoji(
    "A passionate Full Stack Software Developer and AWS Certified Solutions Architect 🚀 with experience in building web and mobile applications using TypeScript, React.js, React Native, C#, .NET, and various modern libraries and frameworks. Committed to writing clean, maintainable code and delivering scalable solutions that enhance user experiences."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1qjAuDwEG7pD_0eacPgC3-b-05PwyKepr/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Pipi144",
  linkedin: "https://www.linkedin.com/in/phat-truong-8875a6268/",
  gmail: "petertp144@gmail.com",
  gitlab: "https://gitlab.com/Pipi144",
  facebook: "https://www.facebook.com/truongmp/",
  medium: "https://medium.com/@petertp144",
  stackoverflow:
    "https://stackoverflow.com/users/18386971/ph%c3%a1t-tr%c6%b0%c6%a1ng",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end - Back end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji("⚡ Integration of third party services such as Auth0/ AWS / Azure")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },

    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Academy Of Information Technology",
      logo: require("./assets/images/aitLogo.png"),
      subHeader: "Bachelor Of Information Technology",
      duration: "October 2017 - June 2020",
      desc: "Focused on software development, mobile application design, and full-stack web technologies. Graduated with a GPA of 4.",
      descBullets: [
        "Completed projects using React Native, ReactJs, Android, Objective-C and Arduino.",
        "Developed mobile applications with user-friendly UI/UX principles.",
        "Collaborated on team-based projects following Agile methodologies."
      ]
    },
    {
      schoolName: "Amazon Web Services Training",
      logo: require("./assets/images/awsLogo.png"),
      subHeader: "Solution Architect - Associate (SAA-C03) Certification",
      duration: "Jan 2026 - Jan 2029",
      desc: "Validated expertise in designing and deploying scalable, highly available, and fault-tolerant systems on AWS.",
      descBullets: [
        "Demonstrated proficiency in designing resilient architectures using AWS services including EC2, S3, RDS, Lambda, and CloudFront.",
        "Expertise in implementing secure applications and architectures with IAM, VPC, and AWS security best practices.",
        "Knowledge of cost-optimization strategies and performance efficiency using AWS Well-Architected Framework."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "React", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Nextjs",
      progressPercentage: "80%"
    },
    {
      Stack: "React Native",
      progressPercentage: "85%"
    },
    {
      Stack: ".NET",
      progressPercentage: "80%"
    },
    // {
    //   Stack: "Testing (Both Frontend and Backend)",
    //   progressPercentage: "80%"
    // },
    {
      Stack: "CI/CD",
      progressPercentage: "60%"
    },
    {
      Stack: "AWS",
      progressPercentage: "75%"
    }
    // {
    //   Stack: "Agile",
    //   progressPercentage: "80%"
    // }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, // Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Performio",
      companylogo: require("./assets/images/performioLogo.png"),
      date: "April 2025 – Present",
      desc: "Developing enterprise-grade incentive compensation management solutions with focus on frontend architecture, design systems, and AI-powered productivity enhancements.",
      descBullets: [
        "Collaborated with product owners, designers, and backend teams to develop core frontend features using React and TypeScript, actively maintaining and scaling the internal Design System with ChakraUI, AG-Grid, and Storybook to ensure UI consistency across products.",
        "Pioneered the adoption of AI agents and MCP Figma tools within the engineering workflow, significantly reducing prototyping time and accelerating development velocity.",
        "Increased code reliability by implementing comprehensive testing suites using Jest, React Testing Library, Playwright, and Mock Service Worker, while enforcing strict code review standards.",
        "Managed critical Kanban ticket backlogs and partnered with the Professional Services team to optimize complex SQL queries, improving data retrieval performance.",
        "Maintained CI/CD deployment pipelines using Docker and BuildKite, ensuring seamless delivery of updates.",
        "Engaged in Scrum ceremonies (planning, grooming, stand-ups) to ensure delivery alignment, while documenting technical knowledge in Confluence to support team growth and onboarding."
      ]
    },
    {
      role: "Software Engineer",
      company: "Doxle",
      companylogo: require("./assets/images/doxle.png"),
      date: "January 2023 – December 2024",
      desc: "Led front-end and mobile application development, optimized performance, and collaborated with cross-functional teams to deliver scalable solutions.",
      descBullets: [
        "Led frontend tech stack selection, implementing React, Next.js, React Native, TypeScript, Zustand, Tailwind CSS, and Styled Components to ensure scalability and maintainability",
        "Collaborated with product owners and designers to develop & maintain web and mobile applications (Doxle CRM, Mobile, Draw), streamlining builder workflows and improving project efficiency.",
        "Optimized API interactions with RTK Query, reducing API calls by 40% and enhancing performance.",
        "Built a real-time chat feature using WebSocket, increasing communication efficiency by 30% for builders and office staff.",
        "Implemented unit and integration testing with Jest, React Testing Library, Mock Service Worker, and React Native Testing Library, ensuring robust code quality.",
        "Developed mobile-specific features like background uploads and offline caching for Doxle Mobile, enhancing usability for on-site teams.",
        "Designed reusable UI components and applied clean architecture principles, reducing code duplication and accelerating development.",
        "Containerized applications with Docker, ensuring consistency across development, testing, and deployment.",
        "Worked with CI/CD pipelines using GitHub Actions and AWS services (S3, CloudFront, Amplify) for automated builds and deployments.",
        "Enhanced CVAT, optimizing AI training workflows, improving UI for annotators by 30% and eliminating $10,000 in annual costs by replacing third-party annotation tools.",
        "Developed backend services using Python and Django API Framework, ensuring robust performance and scalability for applications.",
        "Worked with AWS tools such as Aurora, Route53, AWS Lambda and ELB to support scalable and robust deployments.",
        "Practiced Agile methodologies, actively participating in sprint planning, daily stand-ups, and retrospectives",
        "Mentored an intern and a junior developer, conducting code reviews and fostering best practices."
      ]
    },
    {
      role: "Software Engineer",
      company: "Jung Talents",
      companylogo: require("./assets/images/jtLogo.png"),
      date: "September 2020 – July 2024",
      desc: "Worked as an entry-level and freelance software engineer, contributing to multiple projects across web and backend development.",
      descBullets: [
        "Contributed to the Carina Eye Care Website Migration, modernizing the platform with Next.js, TypeScript, and .NET Core Web API, enhancing performance and maintainability.",
        "Developed and maintained PTE Master, an AI-powered education platform, improving students' English proficiency through a scalable and interactive web application.",
        "Built frontend components using React and TypeScript, improving UI responsiveness and accessibility.",
        "Developed and maintained REST APIs using .NET Core Web API with Entity Framework Core (EF Core) and LINQ, optimizing data access and performance.",
        "Integrated Auth0 authentication, enhancing login security and streamlining user access management.",
        "Contributed to the CI/CD pipeline for .NET applications on Azure, leveraging App Services, Azure Functions, GitHub Actions, and Azure DevOps for automated deployments.",
        "Containerized applications with Docker, ensuring consistent development and deployment environments.",
        "Implemented distributed caching with Redis, improving application performance and reducing database load.",
        "Integrated Serilog for structured logging, enhancing debugging and monitoring capabilities.",
        "Collaborated closely with the Senior Tech Lead and Solution Architect on Docker containerization and Azure deployments, improving release efficiency.",
        "Practiced Agile methodologies, participating in sprint planning, daily stand-ups, and retrospectives to ensure continuous iteration and team collaboration.",
        "Wrote and executed unit tests using NUnit (backend) and Jest with React Testing Library (frontend), improving code reliability and reducing production issues.",
        "Mentored an intern and a junior developer, enhancing development workflows through structured code reviews and best practices."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Key Projects Developed at Doxle & Jung Talents",
  projects: [
    // Doxle Projects
    {
      image: require("./assets/images/doxle.png"),
      projectName: "Doxle Platform Suite",
      projectDesc:
        "Comprehensive construction management platform including: (1) Web CRM for managing builder projects, files, defects, and orders with real-time WebSocket collaboration, (2) React Native mobile app with offline caching, push notifications, and background uploads (TestFlight deployed), (3) Enhanced CVAT annotation tool optimizing AI training workflows and eliminating $10,000 in annual costs, (4) Doxle Draw - AI-powered architectural plan analysis tool.",
      footerLink: [
        {
          name: "Web Platform",
          url: "https://projects.doxle.com/"
        },
        {
          name: "Mobile Demo",
          url: "https://drive.google.com/drive/folders/1p-wQhSpk4dgRPNlLs0QDLvZVcWBIgw5j?usp=sharing"
        },
        {
          name: "AI Tools",
          url: "https://doxle.ai/"
        }
      ]
    },

    // Jung Talents Projects
    {
      image: require("./assets/images/carinaLogo.png"),
      projectName: "Carina Eye Care Website Migration",
      projectDesc:
        "Modernized the Carina Eye Care platform using Next.js, TypeScript, and .NET Core Web API, enhancing performance and maintainability.",
      footerLink: [
        {
          name: "Visit Project",
          url: "https://www.carinaeyecare.com.au/"
        }
      ]
    },
    {
      image: require("./assets/images/pteLogo.png"),
      projectName: "PTE Master",
      projectDesc:
        "Developed and maintained an AI-powered education platform using React, TypeScript, and .NET Core Web API, improving students' English proficiency.",
      footerLink: [
        {
          name: "Visit Project",
          url: "https://www.masterpte.com.au/"
        }
      ]
    },
    // Personal Projects

    {
      image: require("./assets/images/quizLogo.png"),
      projectName: "Quiz App",
      projectDesc:
        "Built a full-stack quiz platform with Next.js and .NET Core, integrating Auth0 authentication, role-based authorization, and a scoring system.",
      footerLink: [
        {
          name: "Live Demo",
          url: "https://peter-quizz-app.vercel.app/"
        },
        {
          name: "GitHub Frontend",
          url: "https://github.com/Pipi144/QuizzFE/"
        },
        {
          name: "GitHub Backend",
          url: "https://github.com/Pipi144/QuizzBE/"
        }
      ]
    },
    {
      image: require("./assets/images/fizzLogo.png"),
      projectName: "FizzBuzz Game",
      projectDesc:
        "Developed a game app with Next.js and .NET Core, implementing user/game CRUD with Jest, React Testing Library, MSW (frontend), and NUnit (backend) for robust testing.",
      footerLink: [
        {
          name: "GitHub Repository",
          url: "https://github.com/Pipi144/FizzBuzz"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+61468345457",
  email_address: "petertp144@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
